@if (dialog.active()) {
  <div class="pathways-modal-backdrop" (click)="onBackdropClick()">
    <div
      class="pathways-modal-card feedback-dialog-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="app-feedback-title"
      (click)="$event.stopPropagation()"
    >
      <div class="pathways-title-accent-block">
        <h3 id="app-feedback-title" class="pathways-modal-title">Send feedback</h3>
        <div class="qprime-accent-bar" aria-hidden="true"></div>
      </div>

      <p class="pathways-modal-message feedback-intro">
        We'd love to hear from you! Your feedback — suggestions, compliments, or
        concerns — helps us grow.
      </p>

      <fieldset class="feedback-fieldset">
        <legend>Category</legend>
        <div class="feedback-category-grid" role="radiogroup" aria-label="Feedback category">
          @for (opt of categories; track opt.id) {
            <label class="feedback-category-option">
              <input
                type="radio"
                name="feedbackCategory"
                [value]="opt.id"
                [checked]="category() === opt.id"
                (change)="onCategoryChange(opt.id)"
              />
              <span>{{ opt.label }}</span>
            </label>
          }
        </div>
      </fieldset>

      <div class="feedback-rating-row">
        <span class="feedback-label">Overall rating (optional)</span>
        <div class="feedback-stars" role="group" aria-label="Star rating">
          @for (star of [1, 2, 3, 4, 5]; track star) {
            <button
              type="button"
              class="feedback-star-btn"
              [class.selected]="(rating() ?? 0) >= star"
              [attr.aria-pressed]="rating() === star"
              [attr.aria-label]="star + ' star' + (star === 1 ? '' : 's')"
              (click)="onRatingChange(rating() === star ? null : star)"
            >
              <i class="fa-solid fa-star" aria-hidden="true"></i>
            </button>
          }
        </div>
      </div>

      <label class="feedback-details-field" for="app-feedback-details">
        <span class="feedback-label">Details</span>
        <textarea
          id="app-feedback-details"
          rows="5"
          [attr.maxlength]="detailsMax"
          [ngModel]="details()"
          (ngModelChange)="onDetailsChange($event)"
          [attr.aria-invalid]="detailsError() ? 'true' : 'false'"
          aria-describedby="app-feedback-details-hint app-feedback-details-error"
          placeholder="Describe the bug, idea, or friction…"
        ></textarea>
      </label>
      <div class="feedback-details-meta">
        <span id="app-feedback-details-hint" class="feedback-hint">
          {{ detailsMin }}–{{ detailsMax }} characters ({{ detailsCount() }}/{{ detailsMax }})
        </span>
      </div>
      @if (detailsError(); as err) {
        <p id="app-feedback-details-error" class="feedback-field-error" role="alert">{{ err }}</p>
      }

      <p class="feedback-privacy" role="note">
        Do not include patient information, claim details, or chat transcript content.
      </p>

      @if (submitError(); as message) {
        <p class="feedback-field-error" role="alert">{{ message }}</p>
      }

      <div class="pathways-modal-actions">
        <button
          type="button"
          class="pathways-btn-secondary"
          (click)="close()"
          [disabled]="submitting()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="pathways-btn-primary"
          (click)="onSubmit()"
          [disabled]="!canSubmit()"
        >
          @if (submitting()) {
            Sending…
          } @else {
            Send feedback
          }
        </button>
      </div>
    </div>
  </div>
}
